import React from 'react';
import { DataFilterToolbar } from '@/components/ui/DataFilterToolbar';
import { Database } from 'lucide-react';

export function AgroRatesFilter() {
  const searchConfig = {
    placeholder: 'Tìm kiếm tên, mã vật tư nông học...',
    onChange: () => {}
  };

  const filters = [
    {
      id: 'category',
      label: 'Nhóm vật tư',
      options: [
        { value: 'phan-bon', label: 'Phân bón' },
        { value: 'thuoc-bvtv', label: 'Thuốc BVTV' },
        { value: 'gia-the', label: 'Đất & Giá thể' }
      ],
      value: [],
      onChange: () => {}
    },
    {
      id: 'variance',
      label: 'Biến động',
      options: [
        { value: 'over', label: 'Vượt dự toán' },
        { value: 'under', label: 'Dưới dự toán' },
        { value: 'stable', label: 'Bình ổn' }
      ],
      value: [],
      onChange: () => {}
    }
  ];

  const actions = [
    {
      label: 'Nhập Excel',
      icon: Database,
      onClick: () => {},
      variant: 'outline' as const
    }
  ];

  return (
    <DataFilterToolbar
      searchConfig={searchConfig}
      filters={filters}
      actions={actions}
    />
  );
}
